import { createTypedAsyncThunk, withOrgId } from "../utils/actions";
import * as API from "@/data/api/dashboard-rows";
import { RequestParams, TDashboardRowItem, TDashboardRowPayload } from "@/data/types";
import { State } from "../state/state";

export const getAllDashboardRowsAsync = createTypedAsyncThunk<
  { items: TDashboardRowItem[] },
  RequestParams,
  { state: State }
>("dashboardRows/getAllDashboardRows", async (params, { getState }) => {
  return API.getAllDashboardRows(withOrgId(getState, params));
});

export const createDashboardRowAsync = createTypedAsyncThunk<
  TDashboardRowItem,
  { params?: RequestParams; payload: TDashboardRowPayload },
  { state: State }
>("dashboardRows/createDashboardRow", async ({ params = {}, payload }, { getState }) => {
  return API.createDashboardRow(withOrgId(getState, params), payload);
});

export const getDashboardRowByIdAsync = createTypedAsyncThunk<
  TDashboardRowItem,
  { dashboardRowId: string; params?: RequestParams },
  { state: State }
>("dashboardRows/getDashboardRowById", async ({ dashboardRowId, params = {} }, { getState }) => {
  return API.getDashboardRowById(dashboardRowId, withOrgId(getState, params));
});

export const updateDashboardRowAsync = createTypedAsyncThunk<
  TDashboardRowItem,
  { dashboardRowId: string; params?: RequestParams; payload: Partial<TDashboardRowPayload> },
  { state: State }
>("dashboardRows/updateDashboardRow", async ({ dashboardRowId, params = {}, payload }, { getState }) => {
  return API.updateDashboardRow(dashboardRowId, withOrgId(getState, params), payload);
});

export const deleteDashboardRowAsync = createTypedAsyncThunk<
  { success: boolean },
  { dashboardRowId: string; params?: RequestParams },
  { state: State }
>("dashboardRows/deleteDashboardRow", async ({ dashboardRowId, params = {} }, { getState }) => {
  return API.deleteDashboardRow(dashboardRowId, withOrgId(getState, params));
});